<main-nav>
  <div class="main-nav-overlayer" data-menu-opened={isMenuOpened} onclick={ toggleMenu }>
  </div>

  <div id="horizontal-nav">
    <div class="logo-link">
      <a href="#/">
        <img src={ logo } alt="VLGI">
      </a>
    </div>

    <div class="menu-container">
      <a
        each={ item in topMenu }
        target={item.external ? '_blank' : ''}
        href={ item.external ? item.url : '#' + item.url }
        class={ item.class + ' ' + (item.url.split('?')[0]  == props.route.pathname ? 'activated-link' : '') }
      >
        <span>{ item.name }</span>
      </a>

      <button class="menu-btn-toggle menu-btn-open" data-menu-opened={isMenuOpened} onclick={ toggleMenu }>
        <i class="icon-menu"></i>
        <span>Menu</span>
      </button>
    </div>
  </div>

  <nav id='side-nav' data-menu-opened={isMenuOpened}>
    <button class="menu-btn-toggle menu-btn-close" data-menu-opened={isMenuOpened} onclick={ toggleMenu }>
      <i class="close">&times;</i>
      <span>Fechar</span>
    </button>

    <div class="menu-container">
      <a
        each={ item in sideMenu }
        target={item.external ? '_blank' : ''}
        href={ item.external ? item.url : '#' + item.url }
        class={ item.class + ' ' + (item.url.split('?')[0]  == props.route.pathname ? 'activated-link' : '') }
        onclick= { toggleMenu }
      >
        <span>{ item.name }</span>
      </a>

    </div>
  </nav>

  <script>
    import './main-nav.scss'
    import { sideMenu, topMenu } from './nav.js'
    import logo from '../media/vlg-corporate-logo.svg'
    import * as utils from '../helpers/utils'
    import { route } from '@riotjs/route'

    export default {
      sideMenu, topMenu,
      logo,
      onMounted() {
        this.navHeight = this.root.offsetHeight
        this.currSectionEl = null

        window.addEventListener('load', () => {
          this.handleNavChanges()
          window.addEventListener('scroll', this.handleNavChanges)
          window.addEventListener('force-nav-change', this.changeNavColors)
          route('(.*)').on.value(this.onPageChange)
        })
      },
      onBeforeUnmount() {
        this.isMenuOpened = false
        window.removeEventListener('scroll', this.handleNavChanges)
        window.removeEventListener('force-nav-change', this.changeNavColors)
      },
      toggleMenu(ev) {
        ev.stopPropagation()

        this.isMenuOpened = !this.isMenuOpened
        this.update()

        // toggle menu
        if (this.isMenuOpened) {
          document.documentElement.style.overflowY = 'hidden'
          document.body.scroll = 'no'
        }else {
          document.documentElement.style.overflowY = 'scroll'
          document.body.scroll = 'yes'
        }

      },
      handleNavChanges() {
        const currSectionEl = utils.getCurrentSectionInside(document, 80)

        if (!currSectionEl) throw new Error('Not find an section at this point! Make shure that navbar is above some section')

        if (this.currSectionEl != currSectionEl) {
          this.currSectionEl = currSectionEl
          document.dispatchEvent(new CustomEvent('section-change', {detail:{newSection: currSectionEl}}))
          this.changeNavColors()
        }
        else if (window.pageYOffset < 200) {
          // Allow first transition from transparent to bg color/img
          this.changeNavColors()
        }
      },
      onPageChange () {
        window.scrollTo(0, 0)
        this.handleNavChanges()
      },
      changeNavColors() {
        const windowOffsetY = window.pageYOffset
        const sectionStyle = window.getComputedStyle(this.currSectionEl)
        const currSectionBgColor = sectionStyle.backgroundColor
        const hNav = this.$('#horizontal-nav')

        // Not change color if in the first 60px of the page
        if (windowOffsetY < 60) {
          hNav.style.backgroundColor = 'transparent'
          hNav.style.backgroundImage = null
          hNav.classList.remove('not-at-top')
        } else {
          hNav.classList.add('not-at-top')
          hNav.style.backgroundColor = sectionStyle.backgroundColor

          if (!['mobile', 'tablet'].includes(utils.checkEnvByWidth())) {
            hNav.style.backgroundImage = sectionStyle.backgroundImage
            hNav.style.backgroundAttachment = sectionStyle.backgroundAttachment
            hNav.style.backgroundPositionX = sectionStyle.backgroundPositionX
            hNav.style.backgroundPositionY = sectionStyle.backgroundPositionY
            hNav.style.backgroundSize= sectionStyle.backgroundSize
            hNav.style.backgroundRepeat= sectionStyle.backgroundRepeat
          }
        }

        if (utils.isColorDark(currSectionBgColor)) {
          hNav.classList.remove('nav-dark')
          hNav.classList.add('nav-white')
        } else {
          hNav.classList.remove('nav-white')
          hNav.classList.add('nav-dark')
        }
      }
    }
  </script>
</main-nav>
